import { render, staticRenderFns } from "./Grade11CurriculumLanding.vue?vue&type=template&id=3cfc0401"
import script from "./Grade11CurriculumLanding.vue?vue&type=script&lang=js"
export * from "./Grade11CurriculumLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports